import React from 'react';
import Calendar from '../../../Components/Calendar/Calendar';
import { LOCKER } from '../../../Library/Variables';

const LockerCalendar = () => {
  return <Calendar type={LOCKER} />;
};

export default LockerCalendar;
